import { render, staticRenderFns } from "./basicLayout.vue?vue&type=template&id=411760ec&scoped=true"
import script from "./basicLayout.vue?vue&type=script&lang=js"
export * from "./basicLayout.vue?vue&type=script&lang=js"
import style0 from "./basicLayout.vue?vue&type=style&index=0&id=411760ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411760ec",
  null
  
)

export default component.exports